import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import LeavesTable from "./LeavesTable"

export default function LeavesList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Leaves")} />
        <LeavesTable />
      </div>
    </div>
  )
}
